
const $0b67a4f56115d43c$var$TEMPLATES = [
    // ===== DEEP BALL RALLIES (high percentage = cross-court) =====
    // Neutral rally — cross-court deep is always the right play
    {
        opponentPos: 'baseline-center',
        ballDepth: 'deep',
        ballDirection: 'cross-deep',
        correctReturn: 'cross-deep',
        tactic: "Deep ball, neutral rally \u2192 cross-court deep"
    },
    {
        opponentPos: 'baseline-center',
        ballDepth: 'deep',
        ballDirection: 'line-deep',
        correctReturn: 'cross-deep',
        tactic: "Deep ball \u2192 rally cross-court, don't go for a winner"
    },
    {
        opponentPos: 'baseline-center',
        ballDepth: 'deep',
        ballDirection: 'middle-deep',
        correctReturn: 'cross-deep',
        tactic: "Deep ball to middle \u2192 cross-court deep is safest"
    },
    // Opponent pulled to deuce side — open court is ad, but go behind them if deep
    {
        opponentPos: 'baseline-deuce',
        ballDepth: 'deep',
        ballDirection: 'cross-deep',
        correctReturn: 'cross-deep',
        tactic: "Opponent on deuce side, deep ball \u2192 keep it cross-court behind them"
    },
    {
        opponentPos: 'baseline-wide-deuce',
        ballDepth: 'deep',
        ballDirection: 'cross-deep',
        correctReturn: 'line-deep',
        tactic: "Opponent pulled wide \u2192 now you can change direction down the line"
    },
    // Opponent pulled to ad side
    {
        opponentPos: 'baseline-ad',
        ballDepth: 'deep',
        ballDirection: 'line-deep',
        correctReturn: 'cross-deep',
        tactic: "Opponent on ad side, deep ball \u2192 cross-court to open space"
    },
    {
        opponentPos: 'baseline-wide-ad',
        ballDepth: 'deep',
        ballDirection: 'line-deep',
        correctReturn: 'line-deep',
        tactic: "Opponent pulled wide ad \u2192 change direction down the line"
    },
    // Opponent slightly off-center — still rally, don't go for hero shot
    {
        opponentPos: 'baseline-deuce',
        ballDepth: 'deep',
        ballDirection: 'middle-deep',
        correctReturn: 'cross-deep',
        tactic: "Deep ball, opponent slightly off-center \u2192 still cross-court deep"
    },
    {
        opponentPos: 'baseline-ad',
        ballDepth: 'deep',
        ballDirection: 'middle-deep',
        correctReturn: 'cross-deep',
        tactic: "Deep ball \u2192 don't try to hit a winner, rally cross-court"
    },
    // ===== SHORT BALL = ATTACK =====
    // Short ball, opponent at baseline center — approach to open court
    {
        opponentPos: 'baseline-center',
        ballDepth: 'short',
        ballDirection: 'middle-short',
        correctReturn: 'line-deep',
        tactic: "Short ball! \u2192 approach deep to their weaker side"
    },
    {
        opponentPos: 'baseline-center',
        ballDepth: 'short',
        ballDirection: 'cross-short',
        correctReturn: 'cross-deep',
        tactic: "Short ball! \u2192 attack deep cross-court, take the net"
    },
    // Short ball, opponent deep — drop shot or angle
    {
        opponentPos: 'baseline-center',
        ballDepth: 'short',
        ballDirection: 'middle-short',
        correctReturn: 'cross-short',
        tactic: "Short ball, opponent deep \u2192 angle it short to pull them forward"
    },
    // Short ball, opponent pulled wide — go to open court
    {
        opponentPos: 'baseline-wide-deuce',
        ballDepth: 'short',
        ballDirection: 'middle-short',
        correctReturn: 'line-deep',
        tactic: "Short ball, opponent wide \u2192 attack the open court deep"
    },
    {
        opponentPos: 'baseline-wide-ad',
        ballDepth: 'short',
        ballDirection: 'middle-short',
        correctReturn: 'cross-deep',
        tactic: "Short ball, opponent wide \u2192 attack the open court deep"
    },
    {
        opponentPos: 'baseline-deuce',
        ballDepth: 'short',
        ballDirection: 'cross-short',
        correctReturn: 'line-deep',
        tactic: "Short ball! \u2192 approach deep to the open side"
    },
    {
        opponentPos: 'baseline-ad',
        ballDepth: 'short',
        ballDirection: 'line-short',
        correctReturn: 'cross-deep',
        tactic: "Short ball! \u2192 approach deep to the open side"
    },
    // ===== OPPONENT AT NET = PASS =====
    // Opponent at net deuce — pass down the line
    {
        opponentPos: 'net-deuce',
        ballDepth: 'short',
        ballDirection: 'cross-short',
        correctReturn: 'line-deep',
        tactic: "Opponent at net on deuce \u2192 pass down the line deep"
    },
    {
        opponentPos: 'net-deuce',
        ballDepth: 'deep',
        ballDirection: 'cross-deep',
        correctReturn: 'line-deep',
        tactic: "Opponent at net \u2192 pass down the line, keep it deep"
    },
    // Opponent at net ad — pass cross-court
    {
        opponentPos: 'net-ad',
        ballDepth: 'short',
        ballDirection: 'line-short',
        correctReturn: 'cross-deep',
        tactic: "Opponent at net on ad \u2192 pass cross-court deep"
    },
    {
        opponentPos: 'net-ad',
        ballDepth: 'deep',
        ballDirection: 'line-deep',
        correctReturn: 'cross-deep',
        tactic: "Opponent at net \u2192 pass cross-court deep"
    },
    // Opponent at net center — go to the bigger gap
    {
        opponentPos: 'net-center',
        ballDepth: 'short',
        ballDirection: 'middle-short',
        correctReturn: 'line-deep',
        tactic: "Opponent at net center \u2192 pass down the line deep"
    },
    {
        opponentPos: 'net-center',
        ballDepth: 'deep',
        ballDirection: 'middle-deep',
        correctReturn: 'cross-deep',
        tactic: "Opponent at net \u2192 low cross-court pass"
    }
];
function $0b67a4f56115d43c$var$pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}
function $0b67a4f56115d43c$export$7c0c6d9c89ea1c59(streak) {
    const template = $0b67a4f56115d43c$var$pick($0b67a4f56115d43c$var$TEMPLATES);
    const side = $0b67a4f56115d43c$var$pick([
        'deuce',
        'ad'
    ]);
    // Time limit: starts generous, tightens with streak, floor at 1.2s
    const timeLimit = Math.max(1200, 3000 - streak * 100);
    return {
        side: side,
        ...template,
        timeLimit: timeLimit
    };
}


class $5a7e0bb0908b51fe$export$88530751e3977073 {
    canvas;
    ctx;
    w;
    h;
    // Perspective trapezoid corners (canvas coords)
    cx;
    nearY;
    farY;
    nearHalfW;
    farHalfW;
    constructor(canvas){
        this.canvas = canvas;
        this.w = 0;
        this.h = 0;
        this.cx = 0;
        this.nearY = 0;
        this.farY = 0;
        this.nearHalfW = 0;
        this.farHalfW = 0;
        this.ctx = canvas.getContext('2d');
        this.w = canvas.width;
        this.h = canvas.height;
        this.calcLayout();
    }
    resize(w, h) {
        this.w = w;
        this.h = h;
        this.calcLayout();
    }
    calcLayout() {
        const pad = Math.min(this.w, this.h) * 0.04;
        this.cx = this.w / 2;
        this.nearY = this.h * 0.92;
        this.farY = this.h * 0.10;
        // Near baseline is ~85% of canvas width, far is ~35%
        this.nearHalfW = (this.w - pad * 2) * 0.42;
        this.farHalfW = this.nearHalfW * 0.38;
    }
    // ---- Perspective projection ----
    /** Map normalized court position to canvas coords.
   *  rx: 0=left, 1=right.  ry: 0=near(player), 1=far(opponent). */ perspXY(rx, ry) {
        // Non-linear depth compression: things farther away compress more
        const t = 1 - Math.pow(1 - ry, 0.75);
        const y = this.nearY + (this.farY - this.nearY) * t;
        const halfW = this.nearHalfW + (this.farHalfW - this.nearHalfW) * t;
        const x = this.cx - halfW + rx * halfW * 2;
        return {
            x: x,
            y: y
        };
    }
    /** Inverse: canvas coords to normalized court coords, or null if outside */ canvasToCourt(cx, cy) {
        // Solve for ry first: cy = nearY + (farY - nearY) * t, t = f(ry)
        const totalH = this.farY - this.nearY;
        if (totalH === 0) return null;
        const t = (cy - this.nearY) / totalH;
        if (t < 0 || t > 1) return null;
        // Invert the non-linear mapping: t = 1 - (1-ry)^0.75 → ry = 1 - (1-t)^(1/0.75)
        const ry = 1 - Math.pow(1 - t, 1 / 0.75);
        if (ry < 0 || ry > 1) return null;
        const halfW = this.nearHalfW + (this.farHalfW - this.nearHalfW) * t;
        const leftX = this.cx - halfW;
        const rx = (cx - leftX) / (halfW * 2);
        if (rx < 0 || rx > 1) return null;
        return {
            rx: rx,
            ry: ry
        };
    }
    // ---- Zone geometry ----
    /** Get the 4 corners (trapezoid) of a target zone in canvas coords */ getZoneCorners(zone) {
        // Zones are on opponent's half (ry 0.5 to 1.0)
        // 3 columns: cross(0-0.33), middle(0.33-0.67), line(0.67-1.0)
        // 2 rows: short(0.5-0.72), deep(0.72-1.0)
        const cols = {
            'cross': [
                0.0,
                0.33
            ],
            'middle': [
                0.33,
                0.67
            ],
            'line': [
                0.67,
                1.0
            ]
        };
        const rows = {
            'short': [
                0.50,
                0.72
            ],
            'deep': [
                0.72,
                1.0
            ]
        };
        const [dir, depth] = zone.split('-');
        const [x0, x1] = cols[dir];
        const [y0, y1] = rows[depth];
        return {
            bl: this.perspXY(x0, y0),
            br: this.perspXY(x1, y0),
            tl: this.perspXY(x0, y1),
            tr: this.perspXY(x1, y1)
        };
    }
    /** Check if canvas point is inside a zone (trapezoid hit test) */ getZoneFromPoint(x, y) {
        const court = this.canvasToCourt(x, y);
        if (!court) return null;
        const { rx: rx, ry: ry } = court;
        // Must be on opponent's half
        if (ry < 0.5) return null;
        // Column
        let col;
        if (rx < 0.33) col = 'cross';
        else if (rx < 0.67) col = 'middle';
        else col = 'line';
        // Row
        let row;
        if (ry < 0.72) row = 'short';
        else row = 'deep';
        return `${col}-${row}`;
    }
    /** Convert page coordinates to canvas coordinates */ pageToCanvas(pageX, pageY) {
        const rect = this.canvas.getBoundingClientRect();
        return {
            x: (pageX - rect.left) * (this.canvas.width / rect.width),
            y: (pageY - rect.top) * (this.canvas.height / rect.height)
        };
    }
    // ---- Drawing helpers ----
    drawTrapezoid(tl, tr, br, bl) {
        const ctx = this.ctx;
        ctx.beginPath();
        ctx.moveTo(tl.x, tl.y);
        ctx.lineTo(tr.x, tr.y);
        ctx.lineTo(br.x, br.y);
        ctx.lineTo(bl.x, bl.y);
        ctx.closePath();
    }
    perspLine(rx0, ry0, rx1, ry1) {
        const a = this.perspXY(rx0, ry0);
        const b = this.perspXY(rx1, ry1);
        this.ctx.moveTo(a.x, a.y);
        this.ctx.lineTo(b.x, b.y);
    }
    // ---- Opponent position ----
    getOpponentXY(pos) {
        const positions = {
            'baseline-center': [
                0.50,
                0.97
            ],
            'baseline-deuce': [
                0.30,
                0.97
            ],
            'baseline-ad': [
                0.70,
                0.97
            ],
            'baseline-wide-deuce': [
                0.10,
                0.97
            ],
            'baseline-wide-ad': [
                0.90,
                0.97
            ],
            'net-center': [
                0.50,
                0.65
            ],
            'net-deuce': [
                0.30,
                0.65
            ],
            'net-ad': [
                0.70,
                0.65
            ]
        };
        const [rx, ry] = positions[pos];
        return this.perspXY(rx, ry);
    }
    // ---- Main render ----
    render(state, timerPct) {
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.w, this.h);
        ctx.fillStyle = '#1a1a2e';
        ctx.fillRect(0, 0, this.w, this.h);
        if (state.phase === 'menu') {
            this.drawMenu(state);
            return;
        }
        this.drawCourt();
        if (state.phase === 'playing' && state.currentScenario) {
            this.drawZones(state);
            this.drawScenario(state.currentScenario);
            this.drawTimer(timerPct);
        }
        if ((state.phase === 'wrong' || state.phase === 'timeout') && state.currentScenario) {
            this.drawZones(state);
            this.drawScenario(state.currentScenario);
            this.drawResult(state);
        }
        this.drawHUD(state);
    }
    // ---- Court ----
    drawCourt() {
        const ctx = this.ctx;
        // Court surface — full trapezoid
        const bl = this.perspXY(0, 0);
        const br = this.perspXY(1, 0);
        const tr = this.perspXY(1, 1);
        const tl = this.perspXY(0, 1);
        this.drawTrapezoid(tl, tr, br, bl);
        ctx.fillStyle = '#2d5a27';
        ctx.fill();
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        // Outer boundary
        this.drawTrapezoid(tl, tr, br, bl);
        ctx.stroke();
        // Singles sidelines (inset 12.5% each side)
        const si = 0.125;
        ctx.beginPath();
        this.perspLine(si, 0, si, 1);
        this.perspLine(1 - si, 0, 1 - si, 1);
        ctx.stroke();
        // Net at ry=0.5
        ctx.lineWidth = 3;
        ctx.beginPath();
        this.perspLine(0, 0.5, 1, 0.5);
        ctx.stroke();
        // Service lines
        ctx.lineWidth = 2;
        ctx.beginPath();
        // Near service line (player's side, ry ≈ 0.28)
        this.perspLine(si, 0.22, 1 - si, 0.22);
        // Far service line (opponent's side, ry ≈ 0.78)
        this.perspLine(si, 0.78, 1 - si, 0.78);
        ctx.stroke();
        // Center service lines
        ctx.beginPath();
        this.perspLine(0.5, 0.22, 0.5, 0.5);
        this.perspLine(0.5, 0.5, 0.5, 0.78);
        ctx.stroke();
        // Center baseline marks
        const markDepth = 0.02;
        ctx.beginPath();
        this.perspLine(0.5, 0, 0.5, markDepth);
        this.perspLine(0.5, 1 - markDepth, 0.5, 1);
        ctx.stroke();
    }
    // ---- Zones ----
    drawZones(state) {
        const ctx = this.ctx;
        const zones = [
            'cross-deep',
            'cross-short',
            'line-deep',
            'line-short',
            'middle-deep',
            'middle-short'
        ];
        for (const zone of zones){
            const corners = this.getZoneCorners(zone);
            const isCorrect = state.currentScenario?.correctReturn === zone;
            const isSelected = state.selectedZone === zone;
            const isGameOver = state.phase === 'wrong' || state.phase === 'timeout';
            // Fill
            if (isGameOver) {
                if (isCorrect) {
                    this.drawTrapezoid(corners.tl, corners.tr, corners.br, corners.bl);
                    ctx.fillStyle = 'rgba(78, 204, 163, 0.5)';
                    ctx.fill();
                }
                if (isSelected && !isCorrect) {
                    this.drawTrapezoid(corners.tl, corners.tr, corners.br, corners.bl);
                    ctx.fillStyle = 'rgba(255, 71, 87, 0.5)';
                    ctx.fill();
                }
            } else {
                this.drawTrapezoid(corners.tl, corners.tr, corners.br, corners.bl);
                ctx.fillStyle = 'rgba(255, 255, 255, 0.04)';
                ctx.fill();
            }
            // Dashed border
            this.drawTrapezoid(corners.tl, corners.tr, corners.br, corners.bl);
            ctx.strokeStyle = 'rgba(255, 255, 255, 0.15)';
            ctx.lineWidth = 1;
            ctx.setLineDash([
                4,
                4
            ]);
            ctx.stroke();
            ctx.setLineDash([]);
            // Label
            const midX = (corners.tl.x + corners.tr.x + corners.bl.x + corners.br.x) / 4;
            const midY = (corners.tl.y + corners.tr.y + corners.bl.y + corners.br.y) / 4;
            const [dir, depth] = zone.split('-');
            const fontSize = Math.min(this.nearHalfW * 0.08, 13);
            ctx.fillStyle = 'rgba(255, 255, 255, 0.25)';
            ctx.font = `${fontSize}px -apple-system, system-ui, sans-serif`;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(dir, midX, midY - fontSize * 0.6);
            ctx.fillText(depth, midX, midY + fontSize * 0.6);
        }
    }
    // ---- Scenario (opponent + ball) ----
    drawScenario(scenario) {
        const ctx = this.ctx;
        const radius = Math.min(this.nearHalfW * 0.06, 16);
        // Opponent
        const opp = this.getOpponentXY(scenario.opponentPos);
        ctx.fillStyle = '#ff4757';
        ctx.beginPath();
        ctx.arc(opp.x, opp.y, radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();
        // Label "OPP" inside
        ctx.fillStyle = '#fff';
        ctx.font = `bold ${radius * 0.7}px -apple-system, system-ui, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('OPP', opp.x, opp.y);
        // Ball incoming — figure out where the ball is heading on player's side
        const incomingTarget = this.getIncomingBallTarget(scenario);
        // Player position (near the incoming ball on their side)
        const playerPos = this.perspXY(incomingTarget.rx, 0.05);
        ctx.fillStyle = '#4ecca3';
        ctx.beginPath();
        ctx.arc(playerPos.x, playerPos.y, radius, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 2;
        ctx.stroke();
        ctx.fillStyle = '#fff';
        ctx.fillText('YOU', playerPos.x, playerPos.y);
        // Ball trajectory line
        ctx.strokeStyle = '#ffd700';
        ctx.lineWidth = 2;
        ctx.setLineDash([
            6,
            4
        ]);
        ctx.beginPath();
        ctx.moveTo(opp.x, opp.y);
        ctx.lineTo(playerPos.x, playerPos.y);
        ctx.stroke();
        ctx.setLineDash([]);
        // Ball
        const ballProgress = 0.65;
        const ballX = opp.x + (playerPos.x - opp.x) * ballProgress;
        const ballY = opp.y + (playerPos.y - opp.y) * ballProgress;
        const ballR = Math.min(this.nearHalfW * 0.035, 10);
        ctx.fillStyle = '#ffd700';
        ctx.beginPath();
        ctx.arc(ballX, ballY, ballR, 0, Math.PI * 2);
        ctx.fill();
        ctx.strokeStyle = '#fff';
        ctx.lineWidth = 1;
        ctx.stroke();
        // Ball depth indicator text
        const depthLabel = scenario.ballDepth === 'short' ? 'SHORT BALL!' : 'DEEP';
        const depthColor = scenario.ballDepth === 'short' ? '#ffa502' : '#888';
        ctx.fillStyle = depthColor;
        const labelSize = Math.min(this.w * 0.04, 16);
        ctx.font = `bold ${labelSize}px -apple-system, system-ui, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        ctx.fillText(depthLabel, this.cx, this.nearY + 8);
    }
    /** Where the incoming ball arrives on the player's side (normalized rx) */ getIncomingBallTarget(scenario) {
        const [dir, depth] = scenario.ballDirection.split('-');
        const xMap = {
            'cross': 0.20,
            'middle': 0.50,
            'line': 0.80
        };
        const yMap = {
            'deep': 0.08,
            'short': 0.30
        };
        return {
            rx: xMap[dir] ?? 0.5,
            ry: yMap[depth] ?? 0.1
        };
    }
    // ---- Timer ----
    drawTimer(pct) {
        const ctx = this.ctx;
        const barW = this.w * 0.8;
        const barH = 6;
        const barX = (this.w - barW) / 2;
        const barY = this.h * 0.015;
        ctx.fillStyle = 'rgba(255, 255, 255, 0.1)';
        ctx.fillRect(barX, barY, barW, barH);
        const r = Math.floor(255 * (1 - pct));
        const g = Math.floor(200 * pct);
        ctx.fillStyle = `rgb(${r}, ${g}, 50)`;
        ctx.fillRect(barX, barY, barW * pct, barH);
    }
    // ---- HUD ----
    drawHUD(state) {
        const ctx = this.ctx;
        ctx.fillStyle = '#4ecca3';
        ctx.font = `bold ${Math.min(this.w * 0.06, 28)}px -apple-system, system-ui, sans-serif`;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillText(`${state.score}`, this.w * 0.05, this.h * 0.03);
        if (state.streak > 1) {
            ctx.fillStyle = '#ffd700';
            ctx.font = `bold ${Math.min(this.w * 0.04, 18)}px -apple-system, system-ui, sans-serif`;
            ctx.fillText(`${state.streak}x`, this.w * 0.05, this.h * 0.03 + 30);
        }
        if (state.roundBonus > 0 && state.phase === 'playing') {
            ctx.fillStyle = '#ffd700';
            ctx.font = `bold ${Math.min(this.w * 0.05, 22)}px -apple-system, system-ui, sans-serif`;
            ctx.textAlign = 'center';
            ctx.fillText(`+${state.roundBonus}`, this.w / 2, this.h * 0.03);
        }
        ctx.fillStyle = '#888';
        ctx.font = `${Math.min(this.w * 0.035, 14)}px -apple-system, system-ui, sans-serif`;
        ctx.textAlign = 'right';
        ctx.textBaseline = 'top';
        ctx.fillText(`Best: ${state.bestScore}`, this.w * 0.95, this.h * 0.03);
    }
    // ---- Menu ----
    drawMenu(state) {
        const ctx = this.ctx;
        const cx = this.w / 2;
        const cy = this.h / 2;
        ctx.fillStyle = '#4ecca3';
        ctx.font = `bold ${Math.min(this.w * 0.1, 48)}px -apple-system, system-ui, sans-serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('REFLEX', cx, cy - this.h * 0.18);
        ctx.fillStyle = '#e0e0e0';
        ctx.font = `bold ${Math.min(this.w * 0.08, 36)}px -apple-system, system-ui, sans-serif`;
        ctx.fillText('TENNIS', cx, cy - this.h * 0.10);
        ctx.fillStyle = '#888';
        const instrSize = Math.min(this.w * 0.038, 17);
        ctx.font = `${instrSize}px -apple-system, system-ui, sans-serif`;
        ctx.fillText('Read the court. Tap where to hit.', cx, cy + this.h * 0.02);
        ctx.fillText('Cross-court is safe. Attack short balls.', cx, cy + this.h * 0.06);
        ctx.fillText('Wrong answer = game over.', cx, cy + this.h * 0.10);
        if (state.bestScore > 0) {
            ctx.fillStyle = '#4ecca3';
            ctx.font = `bold ${Math.min(this.w * 0.045, 20)}px -apple-system, system-ui, sans-serif`;
            ctx.fillText(`Best: ${state.bestScore}`, cx, cy + this.h * 0.18);
        }
        const pulse = 0.5 + 0.5 * Math.sin(Date.now() / 500);
        ctx.fillStyle = `rgba(78, 204, 163, ${0.5 + pulse * 0.5})`;
        ctx.font = `bold ${Math.min(this.w * 0.055, 24)}px -apple-system, system-ui, sans-serif`;
        ctx.fillText('TAP TO START', cx, cy + this.h * 0.28);
    }
    // ---- Game Over ----
    drawResult(state) {
        const ctx = this.ctx;
        const cx = this.w / 2;
        // Semi-transparent overlay
        ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
        ctx.fillRect(0, 0, this.w, this.h);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        // Tactic explanation
        if (state.currentScenario?.tactic) {
            ctx.fillStyle = '#ffd700';
            const tacticSize = Math.min(this.w * 0.035, 15);
            ctx.font = `${tacticSize}px -apple-system, system-ui, sans-serif`;
            // Word wrap the tactic text
            const words = state.currentScenario.tactic.split(' ');
            let line = '';
            let lineY = this.h * 0.78;
            for (const word of words){
                const test = line ? `${line} ${word}` : word;
                if (ctx.measureText(test).width > this.w * 0.85) {
                    ctx.fillText(line, cx, lineY);
                    line = word;
                    lineY += tacticSize * 1.4;
                } else line = test;
            }
            if (line) ctx.fillText(line, cx, lineY);
        }
        if (state.phase === 'wrong') {
            ctx.fillStyle = '#ff4757';
            ctx.font = `bold ${Math.min(this.w * 0.08, 36)}px -apple-system, system-ui, sans-serif`;
            ctx.fillText('WRONG', cx, this.h * 0.87);
        } else {
            ctx.fillStyle = '#ffa502';
            ctx.font = `bold ${Math.min(this.w * 0.08, 36)}px -apple-system, system-ui, sans-serif`;
            ctx.fillText('TOO SLOW', cx, this.h * 0.87);
        }
        ctx.fillStyle = '#e0e0e0';
        ctx.font = `${Math.min(this.w * 0.05, 22)}px -apple-system, system-ui, sans-serif`;
        ctx.fillText(`Score: ${state.score}`, cx, this.h * 0.92);
        const pulse = 0.5 + 0.5 * Math.sin(Date.now() / 400);
        ctx.fillStyle = `rgba(255, 255, 255, ${0.4 + pulse * 0.4})`;
        ctx.font = `${Math.min(this.w * 0.04, 18)}px -apple-system, system-ui, sans-serif`;
        ctx.fillText('Tap to try again', cx, this.h * 0.97);
    }
}


const $1d65543a723a8bec$var$BEST_SCORE_KEY = 'reflex-tennis-best';
class $1d65543a723a8bec$export$985739bfa5723e08 {
    container;
    canvas;
    renderer;
    state;
    animFrame;
    boundTap;
    constructor(container){
        this.container = container;
        this.animFrame = 0;
        this.canvas = document.createElement('canvas');
        container.innerHTML = '';
        container.appendChild(this.canvas);
        this.state = {
            phase: 'menu',
            score: 0,
            bestScore: parseInt(localStorage.getItem($1d65543a723a8bec$var$BEST_SCORE_KEY) || '0', 10),
            streak: 0,
            currentScenario: null,
            scenarioStartTime: 0,
            lastReactionTime: 0,
            roundBonus: 0,
            selectedZone: null
        };
        this.renderer = new (0, $5a7e0bb0908b51fe$export$88530751e3977073)(this.canvas);
        this.resize();
        window.addEventListener('resize', ()=>this.resize());
        this.boundTap = (e)=>this.onTap(e);
        this.canvas.addEventListener('touchstart', this.boundTap, {
            passive: false
        });
        this.canvas.addEventListener('mousedown', this.boundTap);
        this.loop();
    }
    resize() {
        const dpr = window.devicePixelRatio || 1;
        const w = this.container.clientWidth;
        const h = this.container.clientHeight;
        this.canvas.width = w * dpr;
        this.canvas.height = h * dpr;
        this.canvas.style.width = `${w}px`;
        this.canvas.style.height = `${h}px`;
        this.renderer.resize(w * dpr, h * dpr);
    }
    loop() {
        this.animFrame = requestAnimationFrame(()=>this.loop());
        let timerPct = 1;
        if (this.state.phase === 'playing' && this.state.currentScenario) {
            const elapsed = Date.now() - this.state.scenarioStartTime;
            timerPct = Math.max(0, 1 - elapsed / this.state.currentScenario.timeLimit);
            if (timerPct <= 0) {
                this.state.phase = 'timeout';
                this.saveBest();
            }
        }
        this.renderer.render(this.state, timerPct);
    }
    onTap(e) {
        e.preventDefault();
        const pageX = 'touches' in e ? e.touches[0].pageX : e.pageX;
        const pageY = 'touches' in e ? e.touches[0].pageY : e.pageY;
        if (this.state.phase === 'menu') {
            this.startGame();
            return;
        }
        if (this.state.phase === 'wrong' || this.state.phase === 'timeout') {
            this.state.phase = 'menu';
            return;
        }
        if (this.state.phase !== 'playing' || !this.state.currentScenario) return;
        const { x: x, y: y } = this.renderer.pageToCanvas(pageX, pageY);
        const zone = this.renderer.getZoneFromPoint(x, y);
        if (!zone) return;
        this.handleAnswer(zone);
    }
    startGame() {
        this.state.score = 0;
        this.state.streak = 0;
        this.state.roundBonus = 0;
        this.state.selectedZone = null;
        this.nextScenario();
    }
    nextScenario() {
        this.state.phase = 'playing';
        this.state.currentScenario = (0, $0b67a4f56115d43c$export$7c0c6d9c89ea1c59)(this.state.streak);
        this.state.scenarioStartTime = Date.now();
        this.state.selectedZone = null;
        this.state.roundBonus = 0;
    }
    handleAnswer(zone) {
        const scenario = this.state.currentScenario;
        const reactionTime = Date.now() - this.state.scenarioStartTime;
        this.state.lastReactionTime = reactionTime;
        this.state.selectedZone = zone;
        if (zone === scenario.correctReturn) {
            // Correct! Score based on speed
            this.state.streak++;
            const timeRatio = 1 - reactionTime / scenario.timeLimit;
            const speedBonus = Math.floor(timeRatio * 100);
            const streakBonus = this.state.streak * 5;
            this.state.roundBonus = 10 + speedBonus + streakBonus;
            this.state.score += this.state.roundBonus;
            // Brief flash then next scenario
            setTimeout(()=>{
                if (this.state.phase === 'playing') this.nextScenario();
            }, 300);
        } else {
            // Wrong — game over
            this.state.phase = 'wrong';
            this.saveBest();
        }
    }
    saveBest() {
        if (this.state.score > this.state.bestScore) {
            this.state.bestScore = this.state.score;
            localStorage.setItem($1d65543a723a8bec$var$BEST_SCORE_KEY, String(this.state.bestScore));
        }
    }
    destroy() {
        cancelAnimationFrame(this.animFrame);
        window.removeEventListener('resize', ()=>this.resize());
        this.canvas.removeEventListener('touchstart', this.boundTap);
        this.canvas.removeEventListener('mousedown', this.boundTap);
    }
}


const $b4e14b6b8da86996$var$container = document.getElementById('app');
new (0, $1d65543a723a8bec$export$985739bfa5723e08)($b4e14b6b8da86996$var$container);


//# sourceMappingURL=reflex-tennis.e80420d1.js.map
